<div>
  <img
    src="../../../assets/images/logo.svg"
    alt="Navtor logo"
  />
  <div class="info">
    <p data-qa-tag="version">Version: {{ version }}</p>
    <p data-qa-tag="buildDate">Build Date: {{ buildDate }}</p>
    @if (qaBuild) {
      <p data-qa-tag="baseUrl">Base URL: {{ baseUrl }}</p>
    }
  </div>
</div>
